module.exports = __webpack_public_path__ + "img/jobSafety_checked.8b65e8aa.png";